import _ from '@lodash';
import LoadingDialog from 'app/admin/common/LoadingDialog';
import { useDispatch, useSelector } from 'react-redux';
import { showMessage } from 'app/store/fuse/messageSlice';
import { Tooltip, Icon, IconButton } from '@material-ui/core';
import { useState } from 'react';
import VizsgazoService from '../service/VizsgazoService';

function TableToolbarPermutationButton(props) {
	const dispatch = useDispatch();
	const [disabled, setDisabled] = useState(false);
	const [loading, setLoading] = useState(false);
	const filterList = useSelector(rootState => rootState.vizsgazoTable.tableBrowserFilter.filterList);

	const handleClick = () => {
		const vizsgaVizsgazo = filterList.find(item => item.propertyName === 'vizsgaVizsgazo');
		if (!_.isUndefined(vizsgaVizsgazo)) {
			setDisabled(true);
			setLoading(true);
			VizsgazoService.deleteAll(vizsgaVizsgazo)
				.then(response => {
					if (response.successful) {
						dispatch({ type: 'vizsgazoTable/event/setNeedDataReload' });
						dispatch(showMessage({ message: 'Összes törlése sikeresen végrehajtva.' }));
					} else {
						const propKeys = Object.keys(response.properties);
						if (propKeys.length > 0) {
							dispatch(showMessage({ message: response.properties[propKeys[0]][0].message }));
						} else {
							dispatch(showMessage({ message: 'Összes törlése nem végrehajtható, vagy hiba történt.' }));
						}
					}
					setDisabled(false);
					setLoading(false);
				})
				.catch(() => {
					setLoading(false);
					dispatch(showMessage({ message: 'Összes törlése nem végrehajtható, vagy hiba történt.' }));
					setDisabled(false);
				});
		} else {
			dispatch(showMessage({ message: 'Kérem válasszon ki egy vizsgasort a szűrők között.' }));
		}
	};
	return (
		<>
			<Tooltip title="Összes törlése">
				<IconButton onClick={() => handleClick()} disabled={disabled}>
					<Icon fontSize="small">remove</Icon>
				</IconButton>
			</Tooltip>
			{loading && <LoadingDialog content="Összes törlése folyamatban" />}
		</>
	);
}

export default TableToolbarPermutationButton;
